import dayjs from 'dayjs';
import {Baecha} from "../types/Baecha";

export const isAfterToday = (dateStr: string) => {
	const date = dayjs(dateStr);
	const today = dayjs().startOf('day');
	return date.isAfter(today);
}

export const formatRelativeTimeOrDate = (dateStr: string) => {
	const date = dayjs(dateStr);
	// 오늘 날짜
	const today = dayjs().startOf('day');

	// 오늘까지는 몇 시간 전으로, 그전 날은 날짜와 시간으로 표시
	return date.isAfter(today)
		? date.fromNow() // 몇 시간 전으로 표시
		: date.format('YYYY년 MM월 DD일 HH:mm'); // 날짜와 시간으로 표시
};

export const formatKorDate = (dateStr: string) => {
	const date = dayjs(dateStr);
	return date.format('YY년 MM월 DD일'); //
}


export const convertCronToKorean = (cronExpression: string): string => {
	const parts = cronExpression.split(' ');
	let seconds = '*';
	let minutes: string, hours: string, dayOfMonth: string, month: string, dayOfWeek: string;

	// Check if the expression has 6 parts (with seconds) or 5 parts (without seconds)
	if (parts.length === 6) {
		[seconds, minutes, hours, dayOfMonth, month, dayOfWeek] = parts;
	} else if (parts.length === 5) {
		[minutes, hours, dayOfMonth, month, dayOfWeek] = parts;
	} else {
		throw new Error('Invalid cron expression: must have 5 or 6 parts.');
	}

	const translateSeconds = (seconds: string) => {
		if (seconds === '*') return '';
		if (seconds.startsWith('*/')) return `매 ${seconds.slice(2)}초마다`;
		return `${seconds}초에`;
	};

	const translateMinutes = (minutes: string) => {
		if (minutes === '*') return '';
		if (minutes.startsWith('*/')) return `매 ${minutes.slice(2)}분마다`;
		return `${minutes}분에`;
	};

	const translateHours = (hours: string) => {
		if (hours === '*') return '';
		if (hours.includes('-')) return `${hours.replace('-', '시부터 ')}시까지`;
		return `${hours}시`;
	};

	const translateDayOfMonth = (dayOfMonth: string) => {
		if (dayOfMonth === '*') return '';
		return `${dayOfMonth}일마다`;
	};

	const translateMonth = (month: string) => {
		if (month === '*') return '';
		return `${month}월마다`;
	};

	const translateDayOfWeek = (dayOfWeek: string) => {
		if (dayOfWeek === '*') return '';
		const days = ['일요일', '월요일', '화요일', '수요일', '목요일', '금요일', '토요일'];
		return dayOfWeek
			.split(',')
			.map((d) => days[parseInt(d)])
			.join(', ');
	};

	const secondsPart = parts.length === 6 ? translateSeconds(seconds) : '';
	const minutesPart = translateMinutes(minutes);
	const hoursPart = translateHours(hours);
	const dayOfMonthPart = translateDayOfMonth(dayOfMonth);
	const monthPart = translateMonth(month);
	const dayOfWeekPart = translateDayOfWeek(dayOfWeek);

	const resultParts = [
		dayOfWeekPart || dayOfMonthPart || '매일',
		monthPart,
		hoursPart,
		minutesPart,
		secondsPart
	]
		.filter((part) => part !== '')
		.join(' ');

	return resultParts.trim();
}

export const getWorkPeriodStr = (baecha: Baecha) => {
	const { isWorkMonth, workDay, workHour } = baecha;

	if (isWorkMonth) return '월대';

	if (workDay === 1) return '하루';
	if (workDay > 1) return `${workDay}일`;

	if (workHour === 1) return '1시간';
	if (workHour === 2) return '2시간';
	if (workHour === 4) return '반나절';

	return '';
}